import { Button, Tooltip } from "antd";
import React from "react";

const BtnRegistration = ({ loading, title='', text='', color="#0995ED", icon='', onClick }) => {
  return (
    <Tooltip title={title}>
      <Button
          onClick={onClick} 
          style={{
            borderColor: color,
            color: color,
            fontFamily: 'Segoe UI',
            fontSize: '12px',
            fontWeight: '500',
            borderRadius: '8px' 
            }} 
          icon={icon} 
          type="primary" 
          ghost
          loading={loading}
      >
        {text}
      </Button>
    </Tooltip>
  )
}

export default BtnRegistration;